/* ============================================================
   Ápice — Shampoo em Óleo Noor Elixir — interatividade
   Progressive enhancement: a página funciona sem JS.
   ============================================================ */

/* ---------- Smooth scroll para âncoras internas ---------- */
document.querySelectorAll(".js-scroll").forEach((el) => {
  el.addEventListener("click", (e) => {
    const href = el.getAttribute("href");
    if (!href || !href.startsWith("#")) return;
    const target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: "smooth", block: "start" });
  });
});

/* ---------- Countdown de urgência (reinicia a cada 24h) ---------- */
function initCountdown() {
  const clocks = document.querySelectorAll("[data-clock]");
  if (!clocks.length) return;
  function tick() {
    const now = new Date();
    const end = new Date(now);
    end.setHours(23, 59, 59, 999);
    let diff = Math.max(0, Math.floor((end - now) / 1000));
    const h = String(Math.floor(diff / 3600)).padStart(2, "0");
    const m = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
    const s = String(diff % 60).padStart(2, "0");
    document.querySelectorAll('[data-clock="h"]').forEach((n) => (n.textContent = h));
    document.querySelectorAll('[data-clock="m"]').forEach((n) => (n.textContent = m));
    document.querySelectorAll('[data-clock="s"]').forEach((n) => (n.textContent = s));
  }
  tick();
  setInterval(tick, 1000);
}
initCountdown();

/* ---------- FAQ accordion ---------- */
const faqItems = document.querySelectorAll(".faq__item");
faqItems.forEach((item) => {
  item.addEventListener("toggle", () => {
    if (item.open) faqItems.forEach((o) => { if (o !== item) o.open = false; });
  });
});

/* ---------- Links de checkout (checkout externo Ápice: seguro.apicecosmeticos.com.br) ---------- */
const STORE = "https://www.apicecosmeticos.com.br";
const CHK = "https://seguro.apicecosmeticos.com.br/r/"; // base do checkout externo
const SHAMPOO_VAR = "48453820383454"; // Shampoo em Óleo 210ml (usado só no combo)
const OIL_VAR = "47892052213982";     // Óleo Capilar Árabe Noor Elixir 60ml
const SHAMPOO = {
  nome: "Shampoo em Óleo",
  url: CHK + "BHB1M6QGNG",
};
// Ritual completo: shampoo + óleo no mesmo carrinho (permalink multi-item).
// Obs.: o óleo precisa estar ATIVO na loja p/ o link funcionar.
const COMBO = {
  nome: "Ritual Completo",
  url: STORE + "/cart/" + SHAMPOO_VAR + ":1," + OIL_VAR + ":1",
};

/* Kits: Shampoo em Óleo + Máscara (por tipo de cabelo).
   Cada um tem seu preço "de" (compare-at) e o mesmo preço final. */
const MASKS = {
  crespo: { nome: "Kit Crespo Brilho",  from: "R$ 95,30",  url: CHK + "GV2FCH1CVU" },
  nutri:  { nome: "Kit Nutri Waves",    from: "R$ 95,30",  url: CHK + "TV8PIA9EC6" },
  cachos: { nome: "Kit Cachos Brilho",  from: "R$ 100,31", url: CHK + "UR4G1EIY6U" },
  ph:     { nome: "Kit Brilho Intacto", from: "R$ 100,71", url: CHK + "CCC3ERFBIM" },
};

const tierRadios = document.querySelectorAll('input[name="tier"]');
const maskRadios = document.querySelectorAll('input[name="mask"]');
const primaryCta = document.querySelector(".oferta [data-cta]");
const maskPick = document.getElementById("maskpick");
const kitFrom = document.getElementById("kit-from");

function syncCta() {
  const tier = document.querySelector('input[name="tier"]:checked');
  if (!tier || !primaryCta) return;

  if (tier.value === "unit") {
    if (maskPick) maskPick.hidden = true;
    primaryCta.href = SHAMPOO.url;
    primaryCta.textContent = "QUERO O SHAMPOO EM ÓLEO →";
  } else if (tier.value === "combo") {
    if (maskPick) maskPick.hidden = true;
    primaryCta.href = COMBO.url;
    primaryCta.textContent = "QUERO O RITUAL COMPLETO →";
  } else {
    if (maskPick) maskPick.hidden = false;
    const chosen = document.querySelector('input[name="mask"]:checked');
    const m = MASKS[chosen ? chosen.value : "crespo"];
    primaryCta.href = m.url;
    primaryCta.textContent = "QUERO O " + m.nome.toUpperCase() + " →";
    if (kitFrom) kitFrom.textContent = m.from;
  }
}
tierRadios.forEach((r) => r.addEventListener("change", syncCta));
maskRadios.forEach((r) => r.addEventListener("change", syncCta));
syncCta();

/* ---------- Botões de compra = funil: pré-selecionam a opção e rolam
   até a seção de opções. A ida ao checkout é o CTA principal da oferta. */
function preselect(tierValue) {
  const tier = document.querySelector('input[name="tier"][value="' + tierValue + '"]');
  if (tier) tier.checked = true;
  syncCta();
}
document.querySelectorAll("[data-buy-tier]").forEach((el) => {
  el.addEventListener("click", () => preselect(el.dataset.buyTier));
});

/* ---------- Reels: autoplay mudo quando visível + tap para som ---------- */
const reels = document.querySelectorAll(".reel");
if (reels.length && "IntersectionObserver" in window) {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const v = entry.target.querySelector(".reel__video");
        if (!v) return;
        if (entry.isIntersecting) v.play().catch(() => {});
        else v.pause();
      });
    },
    { threshold: 0.4 }
  );
  reels.forEach((r) => io.observe(r));

  reels.forEach((reel) => {
    const v = reel.querySelector(".reel__video");
    const btn = reel.querySelector(".reel__sound");
    const toggle = (e) => {
      e.preventDefault();
      const willUnmute = v.muted;
      reels.forEach((other) => {
        const ov = other.querySelector(".reel__video");
        const ob = other.querySelector(".reel__sound");
        if (other !== reel) {
          ov.muted = true;
          other.classList.remove("is-unmuted");
          if (ob) ob.textContent = "🔇";
        }
      });
      v.muted = !willUnmute;
      reel.classList.toggle("is-unmuted", willUnmute);
      if (btn) btn.textContent = willUnmute ? "🔊" : "🔇";
      v.play().catch(() => {});
    };
    reel.addEventListener("click", toggle);
  });
}

/* ---------- CTA flutuante ---------- */
const stickyCta = document.getElementById("stickycta");
const heroEl = document.querySelector(".hero");
const ofertaEl = document.getElementById("oferta");

if (stickyCta && "IntersectionObserver" in window) {
  let pastHero = false;
  let inOferta = false;
  const update = () => {
    if (pastHero && !inOferta) stickyCta.classList.add("is-visible");
    else stickyCta.classList.remove("is-visible");
  };
  new IntersectionObserver(([entry]) => { pastHero = !entry.isIntersecting; update(); }, { threshold: 0 }).observe(heroEl);
  if (ofertaEl) {
    new IntersectionObserver(([entry]) => { inOferta = entry.isIntersecting; update(); }, { threshold: 0.15 }).observe(ofertaEl);
  }
}
